import React from 'react';
import ReactDOM from 'react-dom';
import './CSS/ButtonOnTheMainPageStyle.css';
class Buttonthemainpage extends React.Component  {
    constructor(props) {
        super(props);

      }

         render(){
            return (
              <a href="#MyProjects" target="_blank"><button class="button projButtonSizeStyle"><b>View my work</b></button></a>           
            );
         }
  }
  
  ReactDOM.render (
    <React.StrictMode>
      <Buttonthemainpage/>
    </React.StrictMode>,
    document.getElementById('Buttonthemainpage')
  );
